import { useCallback, useMemo } from 'react';

import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import { WDAC_MANAGED_INSTALLER_QUERY_KEY } from 'src/constants/query';
import { EXPANDED_ROWS_LIMIT } from 'src/constants/table';
import useSubscribeStorage from 'src/hooks/useSubscribeStorage';
import useInfiniteFetch from 'src/queries/useInfiniteFetch';
import useQueryParams from 'src/hooks/useQueryParams';
import { parseQueryToApiQuery } from 'src/utils/query.utils';
import ManagedInstallerService from '../../../../services/managed-installer.service';

const useFetchWDACManagedInstallers = () => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const {
    queryObject: { searchValue: initialSearchValue, filters = {} },
  } = useQueryParams();

  const query = useMemo(
    () =>
      parseQueryToApiQuery({
        filters,
        searchValue: initialSearchValue,
      }),
    [filters, initialSearchValue],
  );

  const fetchFunction = useCallback(
    ({ page, limit }) =>
      ManagedInstallerService.getManagedInstallersAll({
        limit,
        page,
        customerEnvId,
        query,
      }),
    [customerEnvId, query],
  );

  const response = useInfiniteFetch({
    queryKey: [WDAC_MANAGED_INSTALLER_QUERY_KEY, query, customerEnvId],
    fetchFunction,
    expandedRowsLimit: EXPANDED_ROWS_LIMIT,
    itemName: 'managedInstallers',
  });

  return {
    ...response,
    query,
  };
};

export default useFetchWDACManagedInstallers;
